import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './AuthService';



@Component({
  selector: 'app-signout-callback',
  template: `<div></div>`
})

export class SignoutRedirectCallbackComponent implements OnInit {

  private callbackStarted = false;

  constructor(private authService: AuthService,
              private router: Router) { }

  async ngOnInit(): Promise<void> {
    // this._authService.completeLogout().then(_ => {
    //   this._router.navigate(['/logout'], { replaceUrl: true });
    // })
  if (this.callbackStarted) {
      return;
    }

    this.callbackStarted = true;

    try {
      await this.authService.completeLogout();
    } catch (error) {
      console.error(
        'Signout callback failed:',
        error
      );
    }

    await this.router.navigate(
      ['/logout'],
      {
        replaceUrl: true
      }
    );
  }
}